import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { Bullets as Bullets$2, Bullet } from './Bullets.style.js';
import { jsx } from 'react/jsx-runtime';
import useUniqueId from '../../../hooks/useUniqueId.js';

var _excluded = ["items"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Bullets = function Bullets(_ref) {
  var items = _ref.items,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsx(Bullets$2, _objectSpread(_objectSpread({}, rest), {}, {
    children: items.map(function (bullet) {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      return /*#__PURE__*/jsx(Bullet, {
        children: bullet
      }, useUniqueId('bullet'));
    })
  }));
};
var Bullets$1 = Bullets;

export { Bullets$1 as default };
//# sourceMappingURL=Bullets.js.map
